'use strict';

const debounce = require('lodash/debounce');

/**
 * Determines if an HTML element is currently visible within the viewport.
 * @param {HTMLElement} el - The element to check for visibility in the viewport.
 */
const toggleStickyATBOnScroll = function () {
    const originalButton = $('.pdp-right-wrapper .prices-add-to-cart-actions .add-to-cart');
    const notifyMeButton = $('.pdp-right-wrapper .prices-add-to-cart-actions .notify-me-link');
    const $stickyBar = $('.sticky-atb-bar');
    var buttonBottom;

    if ($stickyBar.length > 0) {
        if (originalButton.is(':visible')) {
            buttonBottom = originalButton.offset().top - 155;
        } else {
            buttonBottom = notifyMeButton && notifyMeButton.offset() && notifyMeButton.offset().top - 155;
        }
        const scrollPosition = $(window).scrollTop();

        if (scrollPosition > buttonBottom) {
            $stickyBar.css('display', 'flex').fadeIn();
            $stickyBar.removeClass('d-none'); // Show the sticky atb with a fade-in effect
            $('body').addClass('sticky-atb-active');
        } else {
            $stickyBar.fadeOut();
            $stickyBar.addClass('d-none'); // Hide the sticky atb with a fade-out effect
            $('body').removeClass('sticky-atb-active');
        }
    }
};

$('body').on('click', '.floating-add-to-cart-btn', function () {
    const extraData = { triggeredBy: $('.floating-add-to-cart-btn'), stickyAtb: true };
    $('.add-to-cart').first().trigger('click', extraData);
});

$('body').on('click', '.variations-overlay-content-wrapper .icon-close', function () {
    $('.variations-overlay').addClass('d-none');
});

const stickyHandler = function () {
    // Init call on page load
    toggleStickyATBOnScroll();
    // Adapt on scroll / resize
    $(window).on('orientationchange resize scroll', debounce(toggleStickyATBOnScroll, 15));
};

module.exports = {
    toggleStickyATBOnScroll: toggleStickyATBOnScroll,
    stickyHandler: stickyHandler,
};
